import { Building2, type LucideIcon, Network, Store } from "lucide-react";

export type Brand = {
  id: string;
  label: string;
  blurb: string;
  icon: LucideIcon;
  /** cal.com path (after cal.com/) to schedule against for this brand type. */
  calLink: string;
};

/**
 * Ideal-customer-profile options shown at the start of the demo flow. Boutique
 * studios book a different cal.com event than multi-location/franchise brands.
 */
export const BRANDS: Brand[] = [
  {
    id: "Boutique studio",
    label: "Boutique studio",
    blurb: "One location, big ambitions",
    icon: Store,
    calLink: "team/helios/product-demo",
  },
  {
    id: "Multi-location",
    label: "Multi-location",
    blurb: "A few sites to dozens",
    icon: Building2,
    calLink: "team/helios/product",
  },
  {
    id: "Franchise",
    label: "Franchise",
    blurb: "Corporate and franchisees",
    icon: Network,
    calLink: "team/helios/product",
  },
];
